<template>
    <div class="js-error error-field error-field__state" v-if="message">
        <span v-html="message"/>
    </div>
</template>
<script>
    export default {
        name: 'SsvOrderErrorState',
        props: {
            message: {
                type: String,
                default: null
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/error/ErrorState.vue